<template>
  <div
    v-if="recruitmentImgList.length"
    id="courseDetails"
    class="courses-details-info"
  >
    <h2 class="information-ouline">
      {{ $t('coursesDetail.courseDetails') }}
    </h2>

    <div
      v-for="(item,index) in recruitmentImgList"
      :key="index"
      class="outline-img"
    >
      <img
        v-lazy-load :data-src="item"
        alt=""
        style="width: 780px; border-radius: 10px;"
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detailData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    recruitmentImgList() {
      const imgList = this.detailData.spec.courseInfo.description ? this.detailData.spec.courseInfo.description.split(',') : []
      return imgList
    },
  },

}
</script>
<style lang="scss" scoped>
.courses-details-info {
  padding-top: 34px;
  font-size: 28px;
  font-weight: 600;
  color: rgba(23, 43, 77, 1);
  line-height: 33px;

  .information-ouline {
    width: auto;
    height: 33px;
    margin-bottom: 24px;
    font-size: 32px;
    font-weight: 600;
    color: rgba(23, 43, 77, 1);
    line-height: 38px;
  }

  .outline-img {
    width: 780px;
    height: auto;
  }
}
</style>
